import * as React from 'react';
import { Flex } from 'rebass';
import { Button } from '../';
export default function MessageButtons(_a) {
    var onClick = _a.onClick, _b = _a.buttons, buttons = _b === void 0 ? [] : _b;
    if (!buttons || buttons.length === 0)
        return null;
    return (React.createElement(React.Fragment, null, Array.isArray(buttons) && (React.createElement(Flex, { mt: 2, px: "12px", flexWrap: "wrap" }, buttons.map(function (button, i) { return (React.createElement(Button, { disabled: !onClick, key: (button && button.payload) || "new-button-" + i, onClick: function (event) {
            event.stopPropagation();
            onClick && onClick(button ? button.payload : '');
        }, mr: 1, mb: 1, variant: "primary" }, (button && button.title) || 'New Button')); })))));
}
